// extracted by mini-css-extract-plugin
export default {"body-1":"wSpw_ZHctkNAB4Seyad2","body-2":"NLrqwnRdpHots4S3Ix21","body-3":"vdFlPsSnB3eUR7RuEWY4","ant-typography":"sPirUTks2BIGE9L7Ff_7","exportSettingsButton":"jwMX3nw3YjN6vptNY8Xw"};